import React, { Component } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import classNames from "classnames"

import Button from "components/Button/Button"
import Wrapper from "components/PageMarketingLanding/Wrapper/Wrapper"
import Section from "./Section"

import styles from "./faqSection.css"

export default class FAQSection extends Component {
  static propTypes = {
    buttonText: PropTypes.string,
    sections: PropTypes.array,
    subscribeLink: PropTypes.string,
    title: PropTypes.node,
    customButtonStyle: PropTypes.string,
    headerStyle: PropTypes.string,
    sectionsStyle: PropTypes.string,
    sectionTitleStyle: PropTypes.string,
    sectionDescriptionStyle: PropTypes.string,
    sectionIconStyle: PropTypes.string,
    rootStyle: PropTypes.string,
    iconRootStyle: PropTypes.string,
    darkMode: PropTypes.bool,
  }

  state = {
    openIndex: null,
  }

  onClick = index => {
    this.setState({ openIndex: this.state.openIndex === index ? null : index })
  }

  render() {
    return (
      <div className={classNames(styles.root, { [styles.rootDark]: this.props.darkMode })}>
        <Wrapper rootStyle={this.props.rootStyle}>
          <h2 className={classNames(styles.header, this.props.headerStyle)}>{this.props.title}</h2>
          <div className={classNames(styles.sections, this.props.sectionsStyle, { [styles.sectionsDark]: this.props.darkMode })}>
            {this.props.sections.map((section, index) => {
              const sectionKey = typeof section.title === "string" ? section.title : section.title.props.children

              return (
                <Section
                  index={index}
                  key={sectionKey}
                  onClick={this.onClick}
                  open={this.state.openIndex === index}
                  section={section}
                  titleStyle={this.props.sectionTitleStyle}
                  descriptionStyle={this.props.sectionDescriptionStyle}
                  iconStyle={this.props.sectionIconStyle}
                  iconRootStyle={this.props.iconRootStyle}
                />
              )
            })}
          </div>
          {this.props.subscribeLink && (
            <div className={styles.link}>
              <Link to={this.props.subscribeLink}>
                <Button color={Button.colors.yellowFull} value={this.props.buttonText} customStyle={this.props.customButtonStyle} />
              </Link>
            </div>
          )}
        </Wrapper>
      </div>
    )
  }
}
